module.exports = __webpack_public_path__ + "img/quaro-q.4903c773.svg";